import { render, staticRenderFns } from "./3ActivitateSpringAlive.vue?vue&type=template&id=1c4ba2e2"
import script from "./3ActivitateSpringAlive.vue?vue&type=script&lang=js"
export * from "./3ActivitateSpringAlive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports